var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeetingroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 107,
    viewBox: "0 0 95 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1251 105.627H4.87495C0.88501 105.627 0.88501 103.362 0.88501 100.739V5.70962C0.88501 2.75 1.63501 0.821045 5.49994 0.821045L64.125 0.821045C66.8523 0.821045 68.1221 3.08648 68.1221 5.70962V100.739C68.1531 103.362 67.25 105.627 64.1251 105.627Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.124 42.2078V39.8395C69.124 39.3371 69.5531 38.9783 70.0538 38.9783L83.1416 39.9112C83.6422 39.9112 84.0713 40.2701 84.0713 40.7725V43.1408C84.0713 43.6432 83.6422 44.002 83.1416 44.002L70.0538 43.069C69.5531 43.069 69.124 42.7102 69.124 42.2078Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.124 64.2405V66.6088C69.124 67.1112 69.5531 67.47 70.0538 67.47L83.1416 66.537C83.6422 66.537 84.0713 66.1782 84.0713 65.6758V63.3075C84.0713 62.8051 83.6422 62.4463 83.1416 62.4463L70.0538 63.3793C69.5531 63.3793 69.124 63.7381 69.124 64.2405Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1392 55.126V51.6094C81.1392 47.8775 82.5695 42.7102 87.8619 42.7102C91.5808 42.7102 94.5846 45.7244 94.5846 49.4563V57.7096C94.5846 61.4415 91.5808 64.4558 87.8619 64.4558C83.4993 64.384 81.1392 58.8579 81.1392 55.126Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8618 42.7102C90.651 43.5714 92.6535 46.2268 92.6535 49.3128V57.7814C92.6535 60.8674 90.651 63.5228 87.7903 64.384",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6259 43.1409C70.6259 43.1409 68.1228 43.2844 68.1228 46.3704",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6259 63.3074C70.6259 63.3074 68.1228 63.1639 68.1228 60.0779",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1852 87.1924C24.1852 87.1924 18.2852 82.2701 18.2852 53.7206C18.2852 25.1711 24.1852 19.0674 24.1852 19.0674",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9849 19.5241V86.9241C23.9849 87.5241 24.4849 88.0241 25.0849 88.0241H25.7849C26.3849 88.0241 26.8849 87.5241 26.8849 86.9241V19.5241C26.8849 18.9241 26.3849 18.4241 25.7849 18.4241H25.0849C24.4849 18.4241 23.9849 18.9241 23.9849 19.5241Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3851 59.4241L7.68506 61.6241",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4851 46.9242L7.68506 44.8242",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.585 63.3241L8.38496 61.9241C8.38496 61.9241 7.08496 61.7241 7.08496 60.5241V45.9241C7.08496 45.9241 7.08496 44.9241 8.28496 44.5241L18.685 43.2241",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.485 56.7241C12.3687 56.7241 13.085 55.1571 13.085 53.2241C13.085 51.2911 12.3687 49.7241 11.485 49.7241C10.6014 49.7241 9.88501 51.2911 9.88501 53.2241C9.88501 55.1571 10.6014 56.7241 11.485 56.7241Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.885 56.6241C11.185 56.3241 10.585 54.8241 10.585 53.1241C10.585 51.4241 11.085 50.0241 11.885 49.7241",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9849 64.4242L28.3849 64.6242C28.3849 64.6242 29.8849 64.7242 29.8849 63.3242V43.1242C29.8849 43.1242 29.5849 41.8242 28.4849 41.8242L26.9849 42.0242",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.285 28.4242C40.285 29.9242 39.085 31.1242 37.585 31.1242H33.585C32.085 31.1242 30.885 29.9242 30.885 28.4242C30.885 26.9242 32.085 25.7242 33.585 25.7242H37.585C39.085 25.6242 40.285 26.9242 40.285 28.4242Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7851 28.7243C37.9508 28.7243 38.0851 28.59 38.0851 28.4243C38.0851 28.2586 37.9508 28.1243 37.7851 28.1243C37.6194 28.1243 37.4851 28.2586 37.4851 28.4243C37.4851 28.59 37.6194 28.7243 37.7851 28.7243Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1849 35.3241V71.2241C43.1849 72.1241 42.4849 72.8241 41.5849 72.8241H34.3849C33.4849 72.8241 32.7849 72.1241 32.7849 71.2241V35.3241C32.7849 34.4241 33.4849 33.7241 34.3849 33.7241H41.5849C42.4849 33.7241 43.1849 34.4241 43.1849 35.3241Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingroom);
export default __webpack_public_path__ + "static/media/meetingroom.89350ea5.svg";
export { ForwardRef as ReactComponent };